

export class WaitlistLead{
    email: string = "";
}